<template>
    <div class="row">
        <div class="col-xs-12 text-xs-left">
            <h3 class="modal__title">{{ $t('SEND_ACTIVATION_CODE_1') }}</h3>
            <br />
            <p>
                {{ $t('SEND_ACTIVATION_CODE_2') }}<br />
                {{ $t('SEND_ACTIVATION_CODE_3') }}
            </p>
            <br />
            <form @submit.prevent="sendCode()" novalidate>
                <div class="row">
                    <div class="col-xs-12 col-sm-6 form-group mb-5">
                        <div class="control">
                            <p v-if="errors.has('email')" class="validate-danger">
                                <img src="./../../assets/images/icons/excl-red.svg" />
                                {{ $t('COMPLETE_FIELDS_CORRECTLY') }}
                            </p>

                            <input
                                id="nameWoman"
                                :placeholder="$t('FIRST_NAME')"
                                v-model="nameWoman"
                                type="text"
                                class="col-xs-12 col-sm-6 text-input -white-input-border input"
                                aria-required="true"
                                style="margin-bottom: 10px"
                            />

                            <input
                                id="loginEmail"
                                v-validate="{ required: true, regex: emailRegex }"
                                :class="{ validate: errors.any() }"
                                name="email"
                                :placeholder="$t('EMAIL_ADDRESS')"
                                v-model="email"
                                type="text"
                                class="col-xs-12 col-sm-6 text-input -white-input-border input"
                                aria-required="true"
                            />
                        </div>
                    </div>
                </div>

                <div class="text-center" style="margin-bottom: 20px">
                    <button
                        class="app-btn app-btn--small app-btn-primary-reverse --no-border --no-bg"
                        @click.prevent="$emit('close')"
                    >
                        {{ $t('CANCEL') }}
                    </button>
                    <button class="app-btn app-btn--big app-btn-primary" type="submit">{{ $t('SEND_2') }}</button>
                </div>

                <p style="font-size: 11px" v-html="$t('DATA_ADMINISTRATOR_PURCHASES')"></p>
            </form>
        </div>
    </div>
</template>

<script>
import { config } from './../../main';

export default {
    data() {
        return {
            email: '',
            nameWoman: '',
            emailRegex: config.emailRegex,
        };
    },
    methods: {
        sendCode() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.email = '';
                    this.$emit('sendPackage');
                    this.errors.clear();
                } else {
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// send-activating-code.vue?ae9bf8f8